import { z } from 'zod';
import { grammarPointSchema } from '../grammar-point-schema';

const grammarPointDetailSchemaDefinition = grammarPointSchema.extend({
  id: z.number().int(),
});

export const grammarPointDetailSchema: typeof grammarPointDetailSchemaDefinition =
  grammarPointDetailSchemaDefinition;

export type IGrammarPointDetail = z.infer<typeof grammarPointDetailSchema>;
